export default "__VITE_ASSET__ca240319__"